// extracted by mini-css-extract-plugin
export var root = "ProgramIconsBlock-module--root--icQSN";
export var container = "ProgramIconsBlock-module--container--1iopO";
export var description = "ProgramIconsBlock-module--description--34UD-";
export var programIcon = "ProgramIconsBlock-module--program-icon--2UJ1p";
export var title = "ProgramIconsBlock-module--title--123zo";
export var linkArrow = "ProgramIconsBlock-module--link-arrow--30gPD";